<template>
  <section>
    <div class="map-modal">
      <b-container class="region-container">
        <div class="cont">
          <div class="region-usmap">
            <b-link v-b-modal.modal-map-imglink>
              <img v-bind:src="require(`@/assets/images/regions/region_${thumbnail}`)" alt="Region: Texas" />
            </b-link>
            <b-modal id="modal-map-imglink" title="Select Region" @ok="confirmModalSelection">
              <MapModal v-bind:region="region" v-on:region-select="newRegion" v-on:pic-select="newThumbnail" />
            </b-modal>
          </div>
          <div class="region-text">
            <div class="select-region">
              <span class="select-region__text">{{ regionDisplay }} Region</span>
              <br />
              <b-link v-b-modal.modal-map-link>Select Region</b-link>
              <b-modal id="modal-map-link" title="Select Region" @ok="confirmModalSelection">
                <MapModal
                  v-bind:region="region"
                  :regionId="regionId"
                  v-on:region-select="newRegion"
                  v-on:pic-select="newThumbnail"
                />
                <div></div>
              </b-modal>
            </div>
          </div>

          <div class="region-share">
            <b-button
              v-b-modal.modal-share
              variant="primary"
              class="btn-share btn-icon-share"
            >
              <img
                src="@/assets/images/icon_share.svg"
                alt="Region: Texas"
                width="20"
              />Share Report
            </b-button> 
             <!-- <b-button variant="primary" class="btn-share btn-icon-share" @click="generataPDF">
              Print Report
            </b-button> -->
           <!-- <ShareModal />  -->
         <b-modal id="modal-share" title="Share Report" hide-footer>
              <ShareModal />
            </b-modal>
          </div>
        </div>
      </b-container>
    </div>

    <div id="print-area">
      <ShareModal />
    </div>
    
  </section>
</template>

<script>
import MapModal from './MapModal.vue';
import ShareModal from './ShareModal.vue';
import JQuery from 'jquery';
import axios from 'axios';
import { mapGetters, mapActions, mapState } from 'vuex';

let $ = JQuery;
let url = 'http://api.ipstack.com/check?access_key=11c294f94c7b690d71f93d230a36a2dd';
let yourRegion;

const options = {
  name: '_blank',
  specs: ['fullscreen=no', 'titlebar=no', 'scrollbars=yes'],
  styles: ['https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css']
};

export default {
  name: 'Region',
  props: [],
  components: {
    MapModal,
    ShareModal
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      region: '',
      regionId: null,
      thumbnail: 'texas.svg',
      selectedRegion: 'Texas',
      selectedRegionId: 6,
      selectedThumbnail: ''
    };
  },
  methods: {
    ...mapActions(['changeRegion', 'toggleStorage']),
    // toggleStorage() {
    // }
    // generataPDF() {
    //   this.$htmlToPaper('print-area', options, () => {});
    // },
    confirmModalSelection() {
      this.region = this.selectedRegion;
      this.regionId = this.selectedRegionId;
      this.changeRegion(this.selectedRegionId);
      this.thumbnail = this.selectedThumbnail;
    },
    handleWindowResize(event) {
      // this.windowWidth = event.currentTarget.innerWidth;
      // $('.region').css('width', this.windowWidth - 297);
    },
    newRegion(region, id) {

      this.selectedRegion = region;
      this.selectedRegionId = id;
    },
    newThumbnail(region) {
      let final = '';
      final = region.includes('<br>')
        ? (region = region.replace(/<br\s*\/?>/gi, '_').toLowerCase())
        : region.replace(/ /g, '_').toLowerCase();
      this.selectedThumbnail = final + '.svg';
    },
    setRegion(state) {
      let region;

      switch (state) {
        case 'Washington':
        case 'Oregon':
          region = 'northwest';
          break;
        case 'California':
          region = 'california';
          break;
        case 'Idaho':
        case 'Montana':
        case 'Wyoming':
        case 'Utah':
        case 'Colorado':
        case 'Nevada':
          region = 'mountain north';
          break;
        case 'Arizona':
        case 'New Mexico':
          region = 'southwest';
          break;
        case 'Texas':
          region = 'tx';
          break;
        case 'North Dakota':
        case 'South Dakota':
        case 'Nebraska':
        case 'Kansas':
        case 'Oklahoma':
          region = 'central';
          break;
        case 'Minnesota':
        case 'Iowa':
        case 'Missouri':
        case 'Wisconsin':
        case 'Illinois':
        case 'Michigan':
        case 'Indiana':
          region = 'midwest';
          break;
        case 'Ohio':
        case 'Kentucky':
        case 'Pennsylvania':
        case 'Virginia':
        case 'West Virginia':
        case 'Delaware':
        case 'Maryland':
        case 'New Jersey':
          region = 'midwest';
          break;
        case 'New York':
          region = 'ny';
          break;
        case 'Conneticut':
        case 'Rhode Island':
        case 'Massachusetts':
        case 'New Hamshire':
        case 'Vermont':
        case 'Maine':
          region = 'newengland';
          break;
        default:
          region = 'tx';
          break;
      }

      return region;
    },
    storageState() {
      if (this.storage === true) {
        return 'OFF';
      } else {
        return 'ON';
      }
    }
  },
  computed: {
    ...mapState(['storage']),
    regionDisplay: function() {
      if (this.region === '') {
        this.region = 'Texas';
        this.regionId = 6;
      }
      if (this.region.includes('<br>')) {
        this.region = this.region.replace(/<br\s*\/?>/gi, ' ');
      }
      return this.region;
    }
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowResize);

    axios.get(url).then(response => {
      this.results = response.data;
      yourRegion = this.setRegion(this.results.region_name);
    });
  },
  created() {
    // this.fetchRegion();
  }
};
</script>

<style lang="scss" scoped>
.region-container {
  margin: 0.8rem 0 0.25rem 0;
  min-width: 625px;
  max-width: 100%;

  .select-region {
    margin-left: 0.5rem;
    margin-top: 0;

    .select-region__text {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
}

.cont {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: center;
}

.region-usmap {
  flex: 0 12 auto;
  align-self: flex-start;
  width: 80px;
  min-width: 80px;
  margin-left: 3px;
}

.region-text {
  flex: 0 1 auto;
  align-self: auto;
}

.region-share {
  flex: 2 4 auto;
  align-items: center;

  button {
    width: 100%;
    max-width: 200px;
    float: right;
    margin-right: 3px;

    img {
      margin-right: 0.75rem;
    }
  }
}

#print-area {
  position:absolute;
  top: -99999px;
}
</style>
